import React, { useEffect, useState } from 'react';
import { View, Text, TextInput } from 'react-native';
import { Picker } from '@react-native-picker/picker';
import { DICTIONARY } from '../olonkho-dictionary';
import { OAnswerButton } from '../olonkho-fw';

export default function AdvancedSearch({ navigation }) {
    const [section, setSection] = useState("ALL");
    const [searchText, setSearchText] = useState("");
    const [isButtonDisabled, setButtonDisabled] = useState(true);

    function getDictionary() {
        let dict = (section === "ALL") ? DICTIONARY : DICTIONARY.filter(d => d.type === section);
        return dict.filter((d) => (d.text.toLowerCase().indexOf(searchText.toLowerCase()) > -1) || (d.translate.toLowerCase().indexOf(searchText.toLowerCase()) > -1));
    }

    useEffect(() => {
        if (searchText === "" || searchText.length === 0) {
            setButtonDisabled(true);
        }
        else {
            setButtonDisabled(false);
        }
    }, [searchText]);
    
    return (
        <View style={ { flex: 1 } }>
            <View style={ { flex: 1 } }>
                <View style={ { flexDirection: 'row', alignItems: 'center' } }>
                    <Text style={ { marginLeft: 10 } }>Раздел:</Text>
                    <Picker 
                        style={ { flex: 1  } }
                        selectedValue={ section }
                        onValueChange={(itemValue, itemIndex) => setSection(itemValue)}
                    >
                        <Picker.Item label="Все разделы" value="ALL"/>
                        <Picker.Item label="Архаизмы" value="TYPE_ARCH"/>
                        <Picker.Item label="Историзмы" value="TYPE_HIST"/>
                        <Picker.Item label="Образная лексика" value="TYPE_OBR"/>
                        <Picker.Item label="Заимствованные слова" value="TYPE_RUS"/>
                        <Picker.Item label="Фразеологизмы" value="TYPE_FRAZ"/>
                        <Picker.Item label="Пословицы и поговорки" value="TYPE_POSL"/>
                        <Picker.Item label="Сравнения" value="TYPE_SRAV"/>
                        <Picker.Item label="Эпические формулы" value="TYPE_EPICH"/>
                    </Picker>
                </View>
                <View style={ { flexDirection: 'row', alignItems: 'center' } }>
                    <Text style={ { marginLeft: 10 } }>Текст:</Text>
                    <TextInput
                        placeholder="Введите текст для поиска..."
                        style={ { 
                            flex: 1,
                            height: 40,
                            marginLeft: 10, 
                            marginRight: 10, 
                            paddingLeft: 5,
                            paddingRight: 5,
                            borderColor: 'gray', 
                            borderWidth: 1,
                            borderRadius: 3
                        } }
                        onChangeText={ (text) => {
                            setSearchText(text);
                        } }
                    />
                </View>
            </View>
            { !isButtonDisabled && <OAnswerButton
                title="Начать поиск"
                onPress={ () => {
                    navigation.navigate(
                        'DictionaryPage', 
                        { 
                            items: getDictionary()
                        }
                    );
                } }
            />}
        </View>
    );
}